import { WordMatState } from '@/common/types/wordMat';
import { saveToLocalStorage } from '@/common/utils/localStorage';
import trackMixpanelEvent from '@/common/utils/mixpanel';
import { Button } from '@shadcn/components/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@shadcn/components/dialog';
import { useNavigate } from 'react-router-dom';

interface WordMatCtaModalProps {
  isOpen: boolean;
  onClose: () => void;
  wordMatState: WordMatState | null;
}

export default function WordMatCtaModal({
  isOpen,
  onClose,
  wordMatState,
}: WordMatCtaModalProps) {
  const navigate = useNavigate();

  function handleOpenChange(open: boolean) {
    if (!open) {
      trackMixpanelEvent('Word Mat Save CTA Modal Dismissed', {
        source: 'wordmat-micronav',
      });
      onClose();
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-[640px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl">
            Save & edit Word Mats for free
          </DialogTitle>
          <DialogDescription>
            You can save and edit Word Mats for free with a Spellcaster account.
            Create, customise, and save multiple word mats for you and your
            team.
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-lg overflow-hidden bg-gray-100">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="w-full"
            src="/videos/wordmat-explainer.mp4"
          />
        </div>

        <div className="flex items-center justify-between pt-2">
          <Button
            variant="link"
            className="px-0 text-sm"
            onClick={() => {
              trackMixpanelEvent('Word Mat Save CTA Log In Clicked', {
                source: 'wordmat-micronav',
              });
              if (wordMatState) saveToLocalStorage('wordMatDraft', JSON.stringify(wordMatState));
              saveToLocalStorage('redirect', '/dashboard/wordmats/new?from=public');
              onClose();
              navigate('/login');
            }}
          >
            Already have an account? Log in
          </Button>
          <Button
            onClick={() => {
              trackMixpanelEvent('Word Mat Save CTA Sign Up Clicked', {
                source: 'wordmat-micronav',
              });
              if (wordMatState) saveToLocalStorage('wordMatDraft', JSON.stringify(wordMatState));
              saveToLocalStorage('redirect', '/dashboard/wordmats/new?from=public');
              onClose();
              navigate('/signup');
            }}
          >
            Sign up for free
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
